var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_config = require("cio-config");

var SnapLineType = require("./../snap/snapLineType.js");
var SnapSet = require("./../snap/snapSet.js");

var OriginInteractionModel = require("./originInteractionModel.js");

/**
 * The purpose of this file is to contain the origin model.
 * Responsibilities of the origin model are to encapsulate the grid and snap functionality.
 *
 * created by Johan VdB 25/6/2014
 */

var OriginModel = function(cameraModel, editorModel, position, options) {
    var self = this;
    lib_core.Model.apply(this);

    this.cameraModel = cameraModel;
    this.editorModel = editorModel;

    // TODO interactionModel shouldn't be created here!!
    this.interactionModel = this.value("interactionModel", true);
    this.interactionModel(new OriginInteractionModel(this));

    this.position = this.value('position', true, lib_geometry.Coord.validator);

    //fields and default values
    this.grid_value = this.value('grid_value', true, cio_config.types.positive_float.validator);
    this.grid_unit = this.value('grid_unit', true);
    this.grid_show = this.value('grid_show', true, cio_config.types.boolean.validator);
    this.origin_show = this.value('origin_show', true, cio_config.types.boolean.validator);
    this.grid_thickness = this.value('grid_thickness', true, cio_config.types.positive_float.validator);
    this.units = ['um', 'mm', 'mil'];

    //this.selected = this.value('selected', false, false, true);

    this.lines = this.shadow("lines",
        this.getLines,
        null,
        [this.cameraModel.workplane, this.grid_unit, this.grid_value, this.position]
    );

    // TODO: stuff explodes when we add this shadow because of onBubble
    // this.snapSetTo = this.shadow("snapSetTo", false,
    //     function () {
    //         return self._getSnapSet(SnapLineType.TO);
    //     },
    //     null,
    //     [[this.cameraModel.viewS, this.cameraModel.viewS.onChange],
    //      [this.cameraModel.viewY, this.cameraModel.viewY.onChange],
    //      [this.cameraModel.viewX, this.cameraModel.viewX.onChange],
    //      [this.editorModel.canvasRect, this.editorModel.canvasRect.onChange],
    //      [this.grid_unit, this.grid_unit.onChange],
    //      [this.grid_value, this.grid_value.onChange],
    //      [this.position, this.position.onChange]]
    // );

    this.showUnitString = this.shadow("showUnitString",
        this.getGridUnitString,
        null,
        [this.grid_unit]
    );

    if (position) this.position(position);
    else this.position(new lib_geometry.Coord(0, 0));
    if (options) this.initModel(options);
    if (options && options.theme) this.theme = options.theme;
};
lib_core.inherit(OriginModel, lib_core.Model);
lib_core.JsonParser.registerClass(OriginModel, "OriginModel");

module.exports = OriginModel;

OriginModel.prototype.initModel = function(options){
    if(options.grid_value !== undefined) this.grid_value(options.grid_value);
    else this.grid_value(10);
    if(options.grid_thickness !== undefined) this.grid_thickness(options.grid_thickness);
    else this.grid_thickness(1);
    if(options.grid_unit  !== undefined) this.grid_unit(options.grid_unit);
    else this.grid_unit('pt');
    if(options.grid_show !== undefined) this.grid_show(options.grid_show);
    else this.grid_show(true);
    if(options.origin_show !== undefined) this.origin_show(options.origin_show);
    else this.origin_show(true);
    if (options.units != undefined) this.units = options.units;
    if (options.theme != undefined) this.theme = options.theme;
    if (options.gridFill != undefined) this.gridFill = options.gridFill;
    if (options.gridSectorFill != undefined) this.gridSectorFill = options.gridSectorFill;
    if (options.gridOriginSize != undefined) this.gridOriginSize = options.gridOriginSize;
    if (options.gridOriginFill != undefined) this.gridOriginFill = options.gridOriginFill;
    if (options.gridBackground != undefined) this.gridBackground = options.gridBackground;
};

OriginModel.prototype.getGridFactor = function () {
    var factor = 1;

    switch (this.grid_unit()) {
        case "px": break; // TODO: confusion unit because #pixels is relative to resolution...
        case "vm": break; // unit of breadboard: 1 vali-meter.
        case "um": break;
        case "mil": factor = cio_config.UnitConversions.Mils.toMicrometers(1); break;
        case "mm":  factor = cio_config.UnitConversions.Millimeters.toMicrometers(1);  break;
    }

    return factor;
};

OriginModel.prototype.getGridSpacing = function () {
    return this.grid_value() * this.getGridFactor();
};

OriginModel.prototype.getDisplacement = function(factor) {
    var gridSpacing = this.getGridSpacing();

    return new lib_geometry.Coord(factor * gridSpacing, factor * gridSpacing);
};

OriginModel.prototype.getLines = function() {
    var x,
        y,
        i,
        gridline;

    var hor = new lib_core.Collections.HashSet();
    var ver = new lib_core.Collections.HashSet();

    var workplane = this.cameraModel.workplane();

    var position = this.position();
    var grid = this.getGridSpacing();

    var screenSpacing = this.cameraModel.viewS()*grid;
    // only show lines devisible by factor, depandant on screenspacing: factor = 1 (every line is shown), 2 (half of lines is shown), 5, 10, 20, 40, 80, ...
    var factor = (screenSpacing > 2) ? 1 :
        (screenSpacing > 1) ? 2 :
            (screenSpacing > 0.4) ? 5 :
            10*Math.pow(2,Math.ceil(Math.log(2/10/screenSpacing)*Math.LOG2E));

    var allowLine = function(idx){
        return (idx%factor == 0);
    };

    if (grid !== 0) {

        // positive x-axis (vertical)
        x = position.x;
        i = 0;
        while (x <= workplane.getXMax()) {
            if (allowLine(i)) {
                gridline = {
                    x1: x,
                    y1: workplane.getYMin(),
                    x2: x,
                    y2: workplane.getYMax(),
                    index: i
                };
                ver.add(gridline);
            }
            x += grid;
            i++;
        }

        // negative x-axis (vertical)
        x = position.x;
        i = 0;
        while (x >= workplane.getXMin()) {
            if (allowLine(i)) {
                gridline = {
                    x1: x,
                    y1: workplane.getYMin(),
                    x2: x,
                    y2: workplane.getYMax(),
                    index: i
                };
                ver.add(gridline);
            }
            x -= grid;
            i--;
        }

        // positive y-axis (horizontal)
        y = position.y;
        i = 0;
        while (y <= workplane.getYMax()) {
            if (allowLine(i)) {
                gridline = {
                    x1: workplane.getXMin(),
                    y1: y,
                    x2: workplane.getXMax(),
                    y2: y,
                    index: i
                };
                hor.add(gridline);
            }
            y += grid;
            i++;
        }

        // negative y-axis (horizontal)
        y = position.y - grid;
        i = -1;
        while (y >= workplane.getYMin()) {
            if (allowLine(i)) {
                gridline = {
                    x1: workplane.getXMin(),
                    y1: y,
                    x2: workplane.getXMax(),
                    y2: y,
                    index: i
                };
                hor.add(gridline);
            }
            y -= grid;
            i--;
        }
    }
    return {hor: hor, ver: ver};
};

OriginModel.prototype.getSnapSet = function (type) {
    // switch (type) {
        // case SnapLineType.FROM:
            return this._getSnapSet(type);
        // case SnapLineType.TO:
            // return this.snapSetTo();
    // }
};

OriginModel.prototype._getSnapSet = function(type) {
    var self = this;
    var result = new SnapSet();

    if (type === SnapLineType.FROM) {
        result.add(this.position().copy(),1);
    }

    if (type === SnapLineType.TO) {
        if (this.grid_show()) {
            var lines = this.getLines();

            lines.ver.forEach(function(gridline){
                result.addVer(new lib_geometry.Coord(gridline.x1,0), 1, 0, null, self, 0, null, null);
            });

            lines.hor.forEach(function(gridline){
                result.addHor(new lib_geometry.Coord(0,gridline.y1), 1, 0, null, self, 0, null, null);
            });
        }
    }

    return result;
};

OriginModel.prototype.getGridUnitString = function() {
    return this.grid_unit().replace('u','\u03BC');
};

OriginModel.prototype.convertX = function(value) {
    return (value || 0) * this.getGridFactor() + this.position().x;
};

OriginModel.prototype.convertY = function(value) {
    return (value || 0) * this.getGridFactor() + this.position().y;
};

OriginModel.prototype.getCoordRelative = function(coord) {
    var x = (coord.x - this.position().x) / this.getGridFactor();
    var y = (coord.y - this.position().y) / this.getGridFactor();
    return new lib_geometry.Coord(x, y);
};
